import React from 'react';
import PropTypes from 'prop-types';

const FirstName = props => <span>{props.data.first_name}</span>;

FirstName.propTypes = {
	data: PropTypes.object.isRequired,
};

export default FirstName;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/first-name.js